import React, { useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import { useNavigate} from "react-router-dom";
import OwButton from "../../../shared/OwButton/OwButton";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IWayfairGetLogsDTO from "../../../../models/DTO/IWayfairGetLogsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IWayfairOnGetLogsDTO from "../../../../models/DTO/IWayfairOnGetLogsDTO";
import INotification from "../../../../models/INotification";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import OwTable from "../../../shared/OwTable/OwTable";
import IOwTableCols from "../../../../models/IOwTableCols";
import IWayfair_Log from "../../../../models/IWayfair_Log";
import moment from "moment";
import {SocketContext} from "../../../../contexts/SocketContext";
import UiContext from "../../../../contexts/UiContext";

type Props = {};

export const WayfairLogViewer: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const renderOperationFn = (row: IWayfair_Log) => {
        return <div>{row.operation}</div>;
    };

    const renderResultFn = (row: IWayfair_Log) => {
        return (
            <div className={"w-35r"}>
                <code className={"w-100 h-10r"}>{row.result}</code>
            </div>
        );
    };

    const renderCreatedAtFn = (row: IWayfair_Log) => {
        return <div className={"w-10r"}>{moment(row.created_at).format("MM/DD/YYYY HH:mm:ss")}</div>;
    };

    const [columns, setColumns] = useState<IOwTableCols[]>([
        {
            title: "created_at",
            renderFn: renderCreatedAtFn,
            renderFnEmitsRow: true,
            valueProp: "",
        },
        {
            title: "operation",
            renderFn: renderOperationFn,
            renderFnEmitsRow: true,
            valueProp: "",
        },
        {
            title: "result",
            renderFn: renderResultFn,
            renderFnEmitsRow: true,
            valueProp: "",
        },
    ]);
    const [logs, setLogs] = useState<IWayfair_Log[]>([]);
    const [isDataFetching, setIsDataFetching] = useState(true);
    const [isInitialData, setIsInitialData] = useState(true);

    const backToPrevious = () => {
        navigate(-1);
    };

    useEffect(() => {
        socket.on(EndpointsEnum.WayfairOnGetLogs, onGetWayfairLogs);

        return () => {
            socket.off(EndpointsEnum.WayfairOnGetLogs, onGetWayfairLogs);
        };
    }, []);

    const getLogs = (offset: number = 0) => {
        const payload: IWayfairGetLogsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.WayfairGetLogs, payload);
    };

    const onGetWayfairLogs = (data: IWayfairOnGetLogsDTO) => {
        const notification: INotification = {
            message: "successfully_retrieved_logs",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        setIsDataFetching(false);
        setIsInitialData(false);
        setLogs(data.logs);
    };

    useEffect(() => {
        getLogs();
    }, []);

    return (
        <div className={"WayfairLogViewer mt-3"}>
            <div>
                <OwButton leftIconClass={"fas fa-chevron-left"} title={"back"} fn={backToPrevious} />
            </div>

            <div className={"mt-3"}>
                <OwTable
                    columns={columns}
                    dataSet={logs}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                />
            </div>
        </div>
    );
};
